module.exports = __webpack_public_path__ + "img/plus.d53ddc98.png";